<template>
    <v-dialog persistent v-model="addEstimateDialog" @keydown.esc="addEstimateDialog = false" max-width="600px">
        <template v-slot:activator="{ on, addEstimateAttrs }">
            <v-btn :color="groupSetting.mainColor" style="float:right" small rounded dark v-bind="addEstimateAttrs" v-on="on">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">진행 예정 입력</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mb-n5">
                        <v-col cols="6">
                            <v-menu
                                    v-model="estimateDateDialog"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="addEstimateAttrs.estimateDate"
                                            label="작성일"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="addEstimateAttrs.estimateDate" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="6">
                            <v-menu
                                    v-model="dueDateDialog"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="addEstimateAttrs.dueDate"
                                            label="납품예정일 *"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            required
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="addEstimateAttrs.dueDate" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n11">
                        <v-col cols="10" xs="12">
                            <v-autocomplete
                                    v-model="addEstimateAttrs.clientId"
                                    :loading="addEstimateClientLoading"
                                    :items="clientList"
                                    :search-input.sync="clientSearch"
                                    no-data-text="일치하는 거래처가 없습니다."
                                    auto-select-first
                                    clear-icon="mdi-format-clear"
                                    flat
                                    label="거래처를 검색해주세요."
                                    solo-inverted
                                    dense
                                    clearable
                                    ref="clientSearchTextField"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" xs="12">
                            <AddClientButton></AddClientButton>
                        </v-col>
<!--                        <v-col cols="6" xs="12">-->
<!--                            <v-text-field label="연락처" hint="거래처 검색 시 자동 입력됩니다." v-model="clientPhone" readonly></v-text-field>-->
<!--                        </v-col>-->
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col cols="4">
                            <v-select
                                    :items="productCategory"
                                    label="품목 *"
                                    item-value="text"
                                    v-model="addEstimateAttrs.category"
                                    required
                            ></v-select>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field label="작업명 *" hint="작업명을 입력하세요." v-model="addEstimateAttrs.title" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col cols="12" class="mb-n9">
                            <v-text-field label="납품장소1" hint="주소를 입력하세요." v-model="addEstimateAttrs.address1"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-select
                                    :items="orderMethodList"
                                    label="납품방법1"
                                    item-value="text"
                                    v-model="addEstimateAttrs.method1"
                            ></v-select>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field label="연락처1" hint="연락처를 입력하세요." v-model="addEstimateAttrs.phone1"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="mb-n9">
                            <v-text-field label="납품장소2" hint="주소를 입력하세요." v-model="addEstimateAttrs.address2"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-select
                                    :items="orderMethodList"
                                    label="납품방법2"
                                    item-value="text"
                                    v-model="addEstimateAttrs.method2"
                            ></v-select>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field label="연락처2" hint="연락처를 입력하세요." v-model="addEstimateAttrs.phone2"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3 mb-n7">
                        <v-textarea
                                outlined
                                name="input-7-4"
                                label="비 고"
                                v-model="addEstimateAttrs.comment"
                        ></v-textarea>
                    </v-row>
                </v-container>
                <small>* 항목은 필수입니다.</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="saveEstimate">저장</v-btn>
                <v-btn color="blue darken-1" text @click="addEstimateDialog = false">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import AddClientButton from "@/components/admin/button/AddClientButton";

export default {
    name: 'AddEstimateDialog',
    components: {
      AddClientButton
    },
    data() {
        return {
            addEstimateClientLoading: false,
            addEstimateDialog: false,
            estimateDateDialog: false,
            dueDateDialog: false,
            clientList: [],
            clientSearch: null,
            clientPhone: '',
            orderMethodList: this.$store.getters.getOrderMethodList,
            productCategory: this.$store.getters.getProductCategoryList,
            addEstimateAttrs: {
                clientId: '',
                division: 'estimation',
                estimateDate: new Date().toISOString().substr(0, 10),
                dueDate: new Date().toISOString().substr(0, 10),
                category: '',
                title: '',
                address1: '',
                method1: '',
                phone1: '',
                address2: '',
                method2: '',
                phone2: '',
                comment: ''
            },
            groupSetting: null
        }
    },
    watch: {
        clientSearch (val) {
            val && val !== this.addEstimateAttrs.clientId && this.querySelections(val)
        },
    },
    methods: {
        saveEstimate() {

            if(this.addEstimateAttrs.estimateDate == this.addEstimateAttrs.dueDate){
                if(!confirm('작성일과 납품 예정일이 같습니다.\n의도하신건가요?')){
                    return false
                }
            }

            if(!this.addEstimateAttrs.clientId){
                alert('거래처를 입력해주세요.')
                return false
            }

            if(!this.addEstimateAttrs.category){
                alert('품목을 선택해주세요.')
                return false;
            }

            if(!this.addEstimateAttrs.title){
                alert('작업명을 입력해주세요.')
                return false;
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/estimate',
                data: this.addEstimateAttrs,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(async response => {

                if(response.data != null && response.data.status && response.data.status == '0000'){

                    //estimate 추가 성공 시
                    alert('정상적으로 추가되었습니다.')
                    this.addEstimateDialog = false

                    this.clearData()
                    await this.$store.dispatch('getEstimates')
                    location.reload()

                }

            })
            .catch((error) => {

                if(error && error.name == "InvalidJwtToken"){

                    //JWT 토큰이 정확하지 않을 시
                    alert('인증 토큰이 유효하지 않습니다.')
                    return false

                }else{

                    //저장 실패 시
                    alert('거래처 등록에 실패했습니다.\n다시 시도해주세요.')

                }

            })

        },
        querySelections (v) {

            this.addEstimateClientLoading = true

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'general',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
                .then(response => {

                    if(response.data != null && response.data.length > 0){

                        this.clientList = []
                        this.phoneNumberList = []

                        if(response.data && response.data[0].value > 0){
                            this.clientList = response.data

                            response.data.forEach(function(item){
                                console.log(item.phone)
                                this.phoneNumberList[item.id].push(item.phone)
                            })
                        }

                        this.addEstimateClientLoading = false

                    }

                })
                .catch(() => {

                    this.addEstimateClientLoading = false

                })

        },
        setClientPhoneNumber(value) {

            //clientId 업데이트
            this.addEstimateAttrs.clientId = value

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/getPhoneNumber',
                data: {
                    id: value,
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.phoneNumber != ''){

                    this.clientPhone = response.data.phoneNumber
                    this.addEstimateClientLoading = false

                }

            })

        },
        clearData() {
            this.addEstimateAttrs.clientId = '',
            this.clientList = [],
            this.clientSearch = null,
            this.clientPhone = '',
            this.addEstimateAttrs.clientPhone = '',
            this.addEstimateAttrs.estimateDate = new Date().toISOString().substr(0, 10),
            this.addEstimateAttrs.dueDate = new Date().toISOString().substr(0, 10),
            this.addEstimateAttrs.category = '',
            this.addEstimateAttrs.title = '',
            this.addEstimateAttrs.address1 = '',
            this.addEstimateAttrs.method1 = '',
            this.addEstimateAttrs.phone1 = '',
            this.addEstimateAttrs.address2 = '',
            this.addEstimateAttrs.method2 = '',
            this.addEstimateAttrs.phone2 = '',
            this.addEstimateAttrs.comment = ''
        }
    },
    created: function() {
        if(this.$store.getters.getAccessToken != null){
            this.groupSetting = this.$store.getters.getGroupSetting
        }
    }
}
</script>